import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';

import s from './DeviationAttributeCSV.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

/** Comma separated locale string values describing certain classifications of deviations
 *  including: mature-level, generated by ai, etc. to be rendered in the details section */
const DeviationAttributeCSV: React.FC<Props> = ({ deviation, className }) => {
  const { t } = useTranslation();
  const { isMature, isNsfg, isAiGenerated } = deviation;

  const values: string[] = [];
  if (isAiGenerated) {
    values.push(t('deviation.details.aiGenerated'));
  }
  if (isMature) {
    values.push(isNsfg ? t('deviation.details.nsfg') : t('deviation.details.mature'));
  }

  return !values.length ? null : (
    <div className={classnames(className, s['root'])}>
      <span>{values.join(', ')}</span>
    </div>
  );
};
DeviationAttributeCSV.displayName = 'DeviationAttributeCSV';

export default DeviationAttributeCSV;
